{
    const applyTrim = () => {
        const LIMIT = 120; 
        const descriptions = document.querySelectorAll('.gm-image .gm-description');

        descriptions.forEach((el) => {
            // CRITICAL: If data-full-text exists, we ALREADY trimmed this. 
            // Skip it to avoid the infinite loop.
            if (el.hasAttribute('data-full-text')) return;

            const rawText = el.textContent.trim();

            if (rawText.length > LIMIT) {
                // Save original text BEFORE we change the DOM
                el.setAttribute('data-full-text', rawText);

                // Apply truncation
                el.textContent = rawText.substring(0, LIMIT).trim() + '...';
                
                el.setAttribute('title', rawText);
                el.style.setProperty('display', 'block', 'important');
                el.style.setProperty('visibility', 'visible', 'important');
            } else {
                // Even if it's short, tag it so the observer doesn't keep checking it
                el.setAttribute('data-full-text', 'short');
                el.removeAttribute('title');
            }
        });
    };

    const observer = new MutationObserver((mutations) => {
        // Only run if the mutations aren't just us adding attributes
        const realMutation = mutations.some(m => m.type === 'childList');
        if (realMutation) {
            applyTrim();
        }
    });

    observer.observe(document.body, {
        childList: true,
        subtree: true
    });

    applyTrim();
}